import { range } from 'lodash';

// ---------- In project imports ----------

import { Button, ButtonGroup, HGap } from './UI';

import Field from './Field';
import * as Game from './copied/Game';

import SharedStyles from './Shared.module.scss';

const { min, max, abs, floor, ceil, round } = Math;

function PlayingStateView(
	{ state, actionLauncher, uid, isAdmin } :
	{
		state: Game.PlayingState,
		actionLauncher: (action: Game.Action, confirmationMessage?: string) => () => Promise<void>,
		uid: string,
		isAdmin: boolean,
	}
) {
	const resetGameTriggered = actionLauncher(
		{ type: Game.ActionType.ResetGame },
		"Are you sure you want to reset game? It can't be undone"
	);

	const scheduleTriggered = actionLauncher({ type: Game.ActionType.Schedule });

	async function distributePointsTriggered() {
		while (true) {
			let apString = window.prompt("How many action points to distribute?");
			if (apString == null)
				return;

			let ap = parseInt(apString);
			if (isNaN(ap))
				continue;

			actionLauncher({
				type: Game.ActionType.TestDistributePoints,
				actionPoints: ap,
				deadReceiveActionPoints: false,
				healthPoints: 0,
				deadReceiveHealthPoints: false,
			})();

			break;
		}
	}

	const me = state.users[uid];

	const maxHeal = floor(me.actionPoints / state.healCost);
	const maxUpgrade = floor(me.actionPoints / state.rangeUpgradeCost);

	return <>
		{isAdmin &&
		<div>
			Admin function:
			<Button label="Reset" onClick={resetGameTriggered} />
			<Button label="Schedule" onClick={scheduleTriggered} />
			<Button label="Distribute points" onClick={distributePointsTriggered} />
		</div>}

		<Field uid={uid}
			state={state}
			actionLauncher={actionLauncher} />

		{state.type === 'started'
		&& <>
			<h3>Self actions</h3>
			<div>
				You have {me.health} health points, {' '}
				{me.actionPoints} action points,
				your range is {me.range}.
				You are {
					me.health > 0
					? <>alive and {me.votesReceived} jury members voted to award you extra point at schedule (you get one extra action point for every {state.scheduleVotesToActionPoints} votes you receive)</>
					: <>dead - the jury member and you have {me.votesAvailable} votes you can use to help some players (each player receives one extra action point at schedule for every {state.scheduleVotesToActionPoints} votes this player receives)</>
				}
			</div>
			<div className={SharedStyles.verticalAlign}>
				Heal: <HGap /> {
					maxHeal <= 0
					? 'not enough action points'
					: <><ButtonGroup>{
						range(1, 1+maxHeal)
						.map(i =>
							<Button key={i} label={i} onClick={actionLauncher({
								type: Game.ActionType.Heal,
								actorId: '',
								count: i,
							})} />
						)
					}</ButtonGroup> <HGap /> - press the number to heal yourself corresponding amount, each health point costs {state.healCost} action points</>
				}
			</div>
			<div className={SharedStyles.verticalAlign}>
				Upgrade: <HGap /> {
					maxUpgrade <= 0
					? 'not enough action points'
					: <><ButtonGroup>{
						range(1, 1+maxUpgrade)
						.map(i =>
							<Button key={i} label={i} onClick={actionLauncher({
								type: Game.ActionType.Upgrade,
								actorId: '',
								count: i,
							})} />
						)
					}</ButtonGroup> <HGap /> - press the number to increase your range by corresponding number, each range point costs {state.healCost} action points</>
				}
			</div>
		</>
		}
		{/*
		<h3>Game rules</h3>
		<h4>Team up and strategize!</h4>
		For that you have chat at the bottom of this page and (probably more importantly) the ability to change your "status" in the right column with a text of up to 200 characters - you can use it to share your contact details, so others can contact and discuss with you privately. <b>Play "outside"!</b> In fact, the game is designed to be played outside: exchange Discord/Telegram details, organize chats, do voice calls - whatever it takes, you are free
		<h4>You control a tank, you can</h4>
		<ul>
			<li>Move orthogonally or diagonally - click on the blue cell to move: moving one cell takes one action point (cells where you can move are highlighted in blue, specified with corresponding move cost depending on the distance)</li>
			<li>Shoot players within you range (hover mouse over them and choose how much damage you want to deal), dealing one damage takes one action point</li>
			<li>Kill other players, player is killed when his/her health becomes zero</li>
			<li>Capture dead player's action points: when you kill a player, you automatically get all this player's action points</li>
			<li>Transfer (=gift) action points or health points to players within your range (hover mouse over the player and choose what and how much you want to transfer). There is no transfer fee - the player receives exactly the same amount you transferred.</li>
			<li>Restore health: each health point costs {state.healCost} action points (in the "Self actions" section)</li>
			<li>Increase your range: each range point costs {state.rangeUpgradeCost} (in the "Self actions" section)</li>
			<li>Revive dead players by transferring them one or more health point</li>
		</ul>
		<h4>You can't</h4>
		<ul>
			<li>Sacrifice your last health point to transfer it to someone else</li>
		</ul>
		<h4>Dead players form "The Jury"</h4>
		<ul>
			<li>You are not out of the game</li>
			<li>You can vote for the player you'd like to help. Every {state.scheduleVotesToActionPoints} votes from the jury award the player extra action point at the "schedule". To vote hover the mouse over the player-cell (not player in the right column) you'd like to vote for.</li>
			<li>Furthermore, you can be revived if someone transfers=gifts you a health point</li>
		</ul>
		<h4>Once every {state.scheduleInterval} hours so called "schedule" happens</h4>
		<ul>
			<li>Dead players (the Jury) each receive {state.scheduleVotesPerDead} vote(s)</li>
			<li>Alive players receive {state.scheduleActionPointsPerAlive} action point(s) each</li>
			<li>In addition to regular received action points, alive player receives extra 1 action point for every {state.scheduleVotesToActionPoints} votes received from the jury</li>
			<li>Votes don't carry over, neither for alive players, nor for jury. Meaning each "schedule" both jury's unused votes and alive players' remaining votes are reset to zero.</li>
		</ul>
		<h3>Last standing player wins</h3>
		In case something is unclear, you want to join discussion or for any other reason, <br />
		join game's official Discord: <a href="https://discord.com/invite/f5XpW3k89v" target="_blank">discord.com/invite/f5XpW3k89v</a> <br />
		or message me on Telegram (@nns2009) <br/>
		Watch the video that inspired the making of this game: <a href="https://youtu.be/aOYbR-Q_4Hs" target="_blank">The Game Prototype That Had to Be Banned by Its Own Studio</a> (it might also help if you are confused about the rules). And by the way, I also have a YouTube channel, where I'll be making video about making this game and how it played out, so if you are curious, subscribe to <a href="https://youtu.be/aP9eKrnyxe4" target="_blank">my YouTube</a> not to miss it.
		*/}
	</>
};

export default PlayingStateView;
